// Persistencia del borrador del formulario de carga de facturas.
//
// Contexto del bug [SUP-000608]: en Android la rotación del dispositivo
// recarga la página, el estado de React se pierde y con él las imágenes
// ya subidas (quedando huérfanas en el servidor). Este módulo guarda en
// sessionStorage los campos e imágenes del formulario para rehidratarlos
// al montar de nuevo el componente. Los borradores se limpian al enviar
// la factura con éxito.
//
// Se usa sessionStorage (no localStorage) para que el borrador muera con
// la pestaña: es un estado transitorio de una carga de factura, no un dato
// duradero.

const DRAFT_FIELDS = [
  "imagen",
  "imagenModal",
  "numeroFactura",
  "fechaFactura",
  "detalle",
  "puntoVenta",
  "puntoVentaTouched",
  "selectedProductos"
];

const KEY_PREFIX = "lizaCargaFacturaDraft_";

// Cada programa (y cada área: web vs backoffice) tiene su propio borrador.
export function getDraftKey(idPrograma, inBackOffice) {
  const area = inBackOffice ? "bo" : "web";
  return `${KEY_PREFIX}${area}_${idPrograma}`;
}

export function saveDraft(idPrograma, inBackOffice, state) {
  const draft = {};
  DRAFT_FIELDS.forEach(field => {
    draft[field] = state[field];
  });

  try {
    window.sessionStorage.setItem(
      getDraftKey(idPrograma, inBackOffice),
      JSON.stringify(draft)
    );
    return true;
  } catch (error) {
    return false;
  }
}

export function loadDraft(idPrograma, inBackOffice) {
  try {
    const raw = window.sessionStorage.getItem(
      getDraftKey(idPrograma, inBackOffice)
    );
    if (!raw) return null;
    const draft = JSON.parse(raw);
    return draft && typeof draft === "object" ? draft : null;
  } catch (error) {
    return null;
  }
}

export function clearDraft(idPrograma, inBackOffice) {
  try {
    window.sessionStorage.removeItem(getDraftKey(idPrograma, inBackOffice));
    return true;
  } catch (error) {
    return false;
  }
}

export function getDraftFields() {
  return DRAFT_FIELDS.slice();
}
